// @react/hooks/useUserprofileBanner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { userprofileBannerStore } from '@core/stores';

/**
 * React hook for Banner operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useUserprofileBanner } from '@react/hooks';
 *
 * const BannerList = observer(() => {
 *   const store = useUserprofileBanner();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useUserprofileBanner() {
  return userprofileBannerStore;
}
